var _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 10,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9391 12.2604L10.0702 17.2169C10.0243 17.2962 10.0001 17.3862 10 17.4778C9.99992 17.5694 10.024 17.6595 10.0698 17.7389C10.1155 17.8183 10.1814 17.8842 10.2608 17.93C10.3401 17.9759 10.4301 18 10.5218 18H16.2596C16.3512 18 16.4412 17.9759 16.5206 17.93C16.5999 17.8842 16.6658 17.8183 16.7116 17.7389C16.7574 17.6595 16.7814 17.5694 16.7813 17.4778C16.7813 17.3862 16.7571 17.2962 16.7112 17.2169L13.8422 12.2604C13.7964 12.1812 13.7306 12.1155 13.6513 12.0698C13.572 12.0241 13.4822 12 13.3907 12C13.2992 12 13.2093 12.0241 13.13 12.0698C13.0508 12.1155 12.9849 12.1812 12.9391 12.2604Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10265 17.7396L9.97156 12.7831C10.0175 12.7038 10.0417 12.6138 10.0417 12.5222C10.0418 12.4306 10.0178 12.3405 9.97199 12.2611C9.92621 12.1817 9.86034 12.1158 9.78099 12.07C9.70164 12.0241 9.61162 12 9.51999 12H3.78217C3.69053 12 3.60051 12.0241 3.52116 12.07C3.44181 12.1158 3.37594 12.1817 3.33016 12.2611C3.28439 12.3405 3.26033 12.4306 3.2604 12.5222C3.26048 12.6138 3.28469 12.7038 3.3306 12.7831L6.19951 17.7396C6.24534 17.8188 6.31119 17.8845 6.39045 17.9302C6.4697 17.9759 6.55959 18 6.65108 18C6.74257 18 6.83245 17.9759 6.91171 17.9302C6.99097 17.8845 7.05681 17.8188 7.10265 17.7396Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44_296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 7.5,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.09375V7.5H19.9062",
    stroke: "#1E1E1E",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.2812C19.5883 11.2812 21.2812 9.58833 21.2812 7.5C21.2812 5.41167 19.5883 3.71875 17.5 3.71875C15.4117 3.71875 13.7188 5.41167 13.7188 7.5C13.7188 9.58833 15.4117 11.2812 17.5 11.2812Z",
    stroke: "#1E1E1E",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4168 3.12479L21.8752 4.58319",
    stroke: "#1E1E1E",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1248 4.58319L14.5832 3.12479",
    stroke: "#1E1E1E",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_296",
    x: 8.83333,
    y: 0,
    width: 17.3333,
    height: 17.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.583333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_296",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticElevator);
export default __webpack_public_path__ + "static/media/static_elevator.1be6ea17ee9042ec7e9379674a2075e9.svg";
export { ForwardRef as ReactComponent };